import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { compose } from 'redux';
import OfferPartnerListQuestionsListComponent from './OfferPartnerListQuestionsListComponent';
import OfferPartnerListQuestionActionsListComponent from './OfferPartnerListQuestionActionsListComponent';
import { Grid } from '@mui/material';
import { Button, IconButton, TextField, Typography } from '@totalsoft/rocket-ui';
import PaginationWrapper from 'components/common/PaginationWrapper';
import CollapseOrBlankCard from 'components/common/CollapseOrBlankCard';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import { RightsContext } from 'providers/RightsContext';

const OfferPartnerListQuestionsListCard = ({
  history,
  documentId,
  siteId,
  totalScore,
  partnerQuestions,
  partnerQuestionsLoaded,
  partnerQuestionActions,
  partnerQuestionActionsLoaded,
  onRealBeneficiaryClick,
  cardExpanded,
  onExpand,
  partnerId,
  onChangeActiveStep,
  pagination,
  onChangeRowsPerPage,
  onChangePage,
  onRefresh,
  fullTextFilter,
  onChangeFilterValue,
  rowsPerPageOptions,
  t
}) => {
  const { isImage, readOnlyFull, partnerQuestionnaireWrite } = useContext(RightsContext);
  const onTextFilterChanged = detailValue => {
    onChangeFilterValue(detailValue);
  };

  const resetFilters = _ => onTextFilterChanged('');

  const onOpenQuestionnaireClick = () => {
    onChangeActiveStep(-1);
    history.push(`/offers/${documentId}/${siteId}/questionnaire/${partnerId}`);
  };
  return (
    <CollapseOrBlankCard
      id={'offerPartnerQuestionsCard'}
      icon={QuestionAnswerIcon}
      title={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.Title')}
      expanded={cardExpanded}
      onToggle={onExpand}
      canExpand={partnerId != null}
    >
      <Grid container item xs={12}>
        {!isImage && (
          <Grid item xs={12} sm={6}>
            <Button
              id={'offerPartnerQuestionnaire_openBtn'}
              color='primary'
              disabled={!partnerQuestionnaireWrite || readOnlyFull}
              onClick={onOpenQuestionnaireClick}
            >
              {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.OpenQuestionnaire')}
            </Button>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            id={'documentVerificationList_filters_fullText'}
            fullWidth={true}
            name='fullTextFilter'
            value={fullTextFilter}
            onChange={value => onTextFilterChanged(value)}
            placeholder={t('Cauta dupa codul sau textul intrebarii')}
            startAdornment={<Search />}
            endAdornment={
              <IconButton
                onClick={resetFilters}
                color='primary'
                variant='text'
                size='tiny'
                tooltip={t('Tooltips.ResetFilters')}
                id={'documentVerificationList_filters_resetBtn'}
              >
                <Close />
              </IconButton>
            }
          />
        </Grid>
        {!partnerQuestionActionsLoaded || !(partnerQuestionActions && partnerQuestionActions.length !== 0) ? (
          <> </>
        ) : (
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <OfferPartnerListQuestionActionsListComponent
                partnerQuestionActions={partnerQuestionActions}
                partnerQuestionActionsLoaded={partnerQuestionActionsLoaded}
                onRealBeneficiaryClick={onRealBeneficiaryClick}
                t={t}
              ></OfferPartnerListQuestionActionsListComponent>
            </Grid>
          </Grid>
        )}
        {!partnerQuestionsLoaded ? (
          <> </>
        ) : (
          <>
            {totalScore && (
              <Grid item xs={12} mb={2}>
                <Typography color='primary' align='left'>
                  {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.TotalScore')}
                  {totalScore}
                </Typography>
              </Grid>
            )}
            <OfferPartnerListQuestionsListComponent
              partnerQuestions={partnerQuestions}
              onExpand={onExpand}
              partnerId={partnerId}
              documentId={documentId}
              siteId={siteId}
              cardExpanded={cardExpanded}
              history={history}
              onChangeActiveStep={onChangeActiveStep}
              editQuestionnaireMode={false}
            />
            <Grid item xs={12} mt={2}>
              <PaginationWrapper
                count={pagination.totalCount}
                pageSize={pagination.pageSize}
                page={pagination.page}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={onChangeRowsPerPage}
                onPageChange={onChangePage}
                onRefresh={onRefresh}
              />
            </Grid>
          </>
        )}
      </Grid>
    </CollapseOrBlankCard>
  );
};
OfferPartnerListQuestionsListCard.propTypes = {
  partnerQuestions: PropTypes.array.isRequired,
  partnerQuestionsLoaded: PropTypes.bool.isRequired,
  partnerQuestionActions: PropTypes.array.isRequired,
  partnerQuestionActionsLoaded: PropTypes.bool.isRequired,
  onRealBeneficiaryClick: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
  partnerId: PropTypes.number,
  documentId: PropTypes.number,
  totalScore: PropTypes.number,
  siteId: PropTypes.number,
  cardExpanded: PropTypes.bool,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onChangeActiveStep: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired
};

export default compose(withTranslation())(OfferPartnerListQuestionsListCard);
